import form from '@wwdev/forms';
import Zipcode from '@wwdev/zipcode';

import './municipality-select';

form.init('form');
Zipcode.init();



